import React from "react";
import styled from "styled-components";
import FunctionsContext from "./FunctionsContext";
import Button from "@material-ui/core/Button";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const Title = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.25px;
  line-height: 24px;
  text-align: left;
`;

const FunctionsListHeader = (props) => {

  return (
    <FunctionsContext.Consumer>
      {(context) => {  
        return (
          <Container>
            <Title>Functions</Title>
            {context.aboutCurrentUser.isAdmin && (
              <Button               
                color="primary"
                variant="contained"
                onClick={() => {
                  context.selectFunction({ id: 0 });
                  context.fetchIWPPApprovers(0);
                }}
              >
                IWPP
              </Button>
            )}
          </Container>
        );
      }}
    </FunctionsContext.Consumer>
  );
};

export default FunctionsListHeader;
